import React, { ReactNode, useContext } from "react";
import { Box, SystemProps, Flex, FlexProps, useScreenSize } from "flicket-ui";
import { BaseContext } from "~context";
import { getImageSrc } from "~lib/helpers";
import { ExtendedFile } from "~graphql/sdk";
import Image from "next/future/image";

interface ContentContainerProps extends Omit<FlexProps, "variant"> {
  children: ReactNode;
  innerProps?: FlexProps;
  variant?: "content";
  image?: ExtendedFile | undefined | null;
  imageFullPage?: ExtendedFile | undefined | null;
}

export const ContentContainer = ({
  children,
  innerProps = {},
  variant,
  image,
  imageFullPage,
  ...props
}: ContentContainerProps) => {
  const { organization } = useContext(BaseContext);
  const { isTabletLandscapeUp } = useScreenSize();

  const bgImage =
    imageFullPage ??
    image ??
    organization.branding?.fullBackground ??
    organization.branding?.background;

  const fullSizedBackground =
    !!imageFullPage || bgImage === organization.branding?.fullBackground;

  return (
    <Flex
      position="relative"
      flex="1"
      flexDir="column"
      bg={variant === "content" && { _: "white", md: "N100" }}
      {...props}
    >
      {isTabletLandscapeUp && (
        <Box
          w="100%"
          zIndex="base"
          height={fullSizedBackground ? "100%" : "360px"}
          position={fullSizedBackground ? "fixed" : "absolute"}
          top={fullSizedBackground ? 0 : "auto"}
          backgroundColor={bgImage ? "transparent" : "P300"}
          backgroundPosition="center"
        >
          {bgImage && (
            <Image
              src={getImageSrc(bgImage, "")}
              fill={true}
              alt="background"
              style={{ objectFit: "cover" }}
              quality={fullSizedBackground ? 90 : 75}
            />
          )}
        </Box>
      )}
      <Flex
        position="relative"
        zIndex="docked"
        pt={variant === "content" ? { _: 2, md: 5 } : 9}
        flex="1"
        flexDir="column"
        {...innerProps}
      >
        {children}
      </Flex>
    </Flex>
  );
};
